import { render, staticRenderFns } from "./qcInfoFrom.vue?vue&type=template&id=2d197d92&"
import script from "./qcInfoFrom.vue?vue&type=script&lang=js&"
export * from "./qcInfoFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports